import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { useState, useEffect, useContext } from "react";
import { Modal, Card, List, Typography, Avatar } from "antd";
import Person from "../../assests/user_avatar.png";
import OrgChart from "../OrgChart";

const { Title, Text } = Typography;

export default function OrgChartList() {
    const { authData, backUrl } = useContext(AuthContext);
    const [hods, setHods] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedHod, setSelectedHod] = useState(null);

    const fetchHod = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/employees/?is_hod=1`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );
            setHods(res.data.results);
        } catch (err) {
            console.error("HOD Fetch Error:", err);
        }
    };

    useEffect(() => {
        fetchHod();
    }, []);

    const handleOpenModal = (hod) => {
        setSelectedHod(hod);
        setOpenModal(true);
    };

    return (
        <>
            <Card style={{ margin: "20px" }}>
                <List
                    itemLayout="horizontal"
                    dataSource={hods}
                    renderItem={(item) => (
                        <List.Item
                            onClick={() => handleOpenModal(item)}
                            style={{
                                cursor: "pointer",
                                padding: "10px",
                                borderRadius: "8px",
                                transition: "0.2s",
                            }}
                            className="hover:bg-gray-100"
                        >
                            <List.Item.Meta
                                title={
                                    <Text strong>
                                        {(item.user?.first_name || "") +
                                            " " +
                                            (item.user?.last_name || "")}
                                    </Text>
                                }
                                description={
                                    <>
                                        <Text type="secondary">
                                            {item.designation_name ??
                                                "No Designation"}
                                        </Text>
                                        <Text>, </Text>
                                        <Text type="secondary">
                                            {item.department_name ??
                                                "No Department"}
                                        </Text>
                                    </>
                                }
                                avatar={
                                    <Avatar
                                        src={item.photo || Person}
                                        size={48}
                                        shape="circle"
                                    />
                                }
                            />
                        </List.Item>
                    )}
                />
            </Card>

            <Modal
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={null}
                width={1300}
                title={`HOD Details – ${
                    selectedHod?.user?.username ??
                    selectedHod?.user?.first_name ??
                    "Employee"
                }`}
            >
                {selectedHod && <OrgChart hodId={selectedHod.id} />}
            </Modal>
        </>
    );
}
